var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxMapWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.5833C14.7979 14.5833 16.6666 12.7146 16.6666 10.4167C16.6666 8.11875 14.7979 6.25 12.5 6.25C10.2021 6.25 8.33331 8.11875 8.33331 10.4167C8.33331 12.7146 10.2021 14.5833 12.5 14.5833ZM12.5 8.33333C13.6489 8.33333 14.5833 9.26771 14.5833 10.4167C14.5833 11.5656 13.6489 12.5 12.5 12.5C11.351 12.5 10.4166 11.5656 10.4166 10.4167C10.4166 9.26771 11.351 8.33333 12.5 8.33333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8958 22.7229C12.0721 22.8488 12.2833 22.9165 12.5 22.9165C12.7166 22.9165 12.9279 22.8488 13.1042 22.7229C13.4208 22.4989 20.8635 17.125 20.8333 10.4166C20.8333 5.82185 17.0948 2.08331 12.5 2.08331C7.9052 2.08331 4.16666 5.82185 4.16666 10.4114C4.13645 17.125 11.5792 22.4989 11.8958 22.7229ZM12.5 4.16665C15.9469 4.16665 18.75 6.96977 18.75 10.4219C18.7719 15.0448 14.1792 19.1958 12.5 20.5573C10.8219 19.1948 6.22811 15.0427 6.24999 10.4166C6.24999 6.96977 9.05311 4.16665 12.5 4.16665Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxMapWhite);
export default __webpack_public_path__ + "static/media/bx_map-white.5a7b30c33a0d7a8d088c3d1878719357.svg";
export { ForwardRef as ReactComponent };